import React from 'react';
import RankingSystem from './RankingSystem.js';
import './Modal.css';

const StatsModal = ({ onClose, stats, isDarkMode, gameMode }) => {
    const winPercentage = (stats?.gamesPlayed > 0) ? Math.round((stats?.gamesWon / stats?.gamesPlayed) * 100) : 0;
    const avgHintsUsed = Math.round(stats?.hintsUsed / stats?.gamesPlayed ?? 1);
    const avgMistakesMade = Math.round(stats?.mistakesMade / stats?.gamesPlayed ?? 1);

    const gameTitle = gameMode === 'connections' ? 'iconn🧩ct' : 'mojie classic';

    return (
        <div className="modal-overlay">
            <div className="modal-content" overlayclassname="overlay">
                <button className="close-button" onClick={onClose}>×</button>
                <div className="stats-header">
                    <h2>{gameTitle} Statistics</h2>
                </div>
                <div className="stats-grid-modern">
                    <div className="stat-card">
                        <span className="stat-icon">🎮</span>
                        <div className="stat-value-modern">{stats?.gamesPlayed || 0}</div>
                        <div className="stat-label-modern">Played</div>
                    </div>
                    <div className="stat-card">
                        <span className="stat-icon">🏆</span>
                        <div className="stat-value-modern">{winPercentage || 0}%</div>
                        <div className="stat-label-modern">Win Rate</div>
                    </div>
                    <div className="stat-card">
                        <span className="stat-icon">💡</span>
                        <div className="stat-value-modern">{avgHintsUsed || 0}</div>
                        <div className="stat-label-modern">Avg Hints</div>
                    </div>
                    <div className="stat-card">
                        <span className="stat-icon">⚪️</span>
                        <div className="stat-value-modern">{avgMistakesMade || 0}</div>
                        <div className="stat-label-modern">Avg Mistakes</div>
                    </div>
                </div>
                <br />
                <div>
                    <RankingSystem gamesWon={winPercentage} isDarkMode={isDarkMode} />
                </div>
            </div>
        </div>
    );
};

export default StatsModal;
